import React, { useEffect } from 'react';
import PageContainer from '../components/containers/PageContainer';
import { Box, Grid, TableCell, TableRow, Typography, Card } from '@mui/material';
import StatCard from '../components/common/StatCard';
import Icon from '../components/common/Icon';
import api from '../config/axios';
import { useState } from 'react';
import { useTheme } from '@emotion/react';
const MarketingStats = () => {
    const [OrderStats, setOrderStats] = useState({});
    const [revenueStats, setRevenueStats] = useState({});
    const [usersStats, setUsersStats] = useState({});
    const [visitCount, setVisitCount] = useState(0);
    const theme = useTheme();
    const getOrdersStat = async () => {
        await api
            .get('/dashboard/morders-stats')
            .then((res) => {
                setOrderStats(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const getUsersStats = async () => {
        await api
            .get('/dashboard/musers-stats')
            .then((res) => {
                setUsersStats(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const getVisitCount = async () => {
        await api
            .get('/dashboard/visits')
            .then((res) => {
                setVisitCount(res.data.visits);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        getUsersStats();
        getOrdersStat();
        getVisitCount();
    }, []);
    return (
        <PageContainer title={'Marketing Stats'} desc="All your marketing statistics at one place.">
            <Grid container spacing={2}>
                <Grid item xs={2} md={2}>
                    <Box mb={2}>
                        <Card
                            elevation={0}
                            sx={{
                                py: 1.2,
                                px: 2,
                                color: theme.palette.primary.main,
                                border: '1px solid rgba(255,255,255,0.1)',
                            }}>
                            <Typography variant="h4" color="white">
                                Total Visits
                            </Typography>

                            <Typography variant="h3" color="white" sx={{ mt: 5, textAlign: 'center' }}>
                                {visitCount}
                            </Typography>
                        </Card>
                    </Box>
                </Grid>
                <Grid item xs={12} md={10}>
                    <Box mb={2}>
                        <StatCard
                            icon={<Icon path="bulk/receipt-2" />}
                            name="Total Registrations"
                            values={Object.values(usersStats)}
                            horizontal
                        />
                    </Box>
                    <Box mb={2}>
                        <StatCard
                            icon={<Icon path="bulk/receipt-2" />}
                            name="Marketing User Orders"
                            values={Object.values(OrderStats)}
                            horizontal
                        />
                    </Box>
                </Grid>
            </Grid>
        </PageContainer>
    );
};

export default MarketingStats;
